var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("商品批号")]),_c('el-cascader',{attrs:{"placeholder":_vm.item,"options":_vm.options},on:{"change":_vm.handleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }